import React, {useState} from "react";
import ForgotPasswordLayer from "./ForgotPasswordLayer.jsx";
import ForgotPasswordConfirmationLayer from "./ForgotPasswordConfirmationLayer.jsx";


const ForgotPasswordStep = {
    FILL_OUT_EMAIL: 'FILL_OUT_EMAIL',
    FEEDBACK: 'FEEDBACK'
}

export default function ForgotPasswordProcessor({texts, siteKey, isCaptchaEnabled, isCaptchaV2Enabled, captchaLang, onClose}) {
    const [currentStep, setCurrentStep] = useState(ForgotPasswordStep.FILL_OUT_EMAIL);

    const [email, setEmail] = useState('');

    const handleUpdateSuccess = (email) => {
        setEmail(email);
        setCurrentStep(ForgotPasswordStep.FEEDBACK);
    }

    if (currentStep !== ForgotPasswordStep.FILL_OUT_EMAIL) {
        return <ForgotPasswordConfirmationLayer texts={texts} email={email} onClose={onClose}/>
    } else {
        return <ForgotPasswordLayer texts={texts}
                                    siteKeyForgotPassword={siteKey}
                                    captchaLang={captchaLang}
                                    isCaptchaEnabled={isCaptchaEnabled}
                                    isCaptchaV2Enabled={isCaptchaV2Enabled}
                                    onUpdateSuccess={handleUpdateSuccess}
                                    onClose={onClose}/>
    }
}
